var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketingBannerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-V1-Account-Summary-Screens---Present-to-Client-(081021)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Account---Option-3-w/Banner---Desktop",
    transform: "translate(-522.000000, -1282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing-Banner-Card",
    transform: "translate(248.000000, 1258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(146.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(128.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FB625B",
    cx: 34,
    cy: 34,
    r: 34
  }), /*#__PURE__*/React.createElement("g", {
    id: "monetization-tablet",
    transform: "translate(17.000000, 15.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4249997,38.2500002 L29.3249998,30.6000001 L29.3249998,21.6750001 C29.3249998,18.2750002 22.8649998,14.6370002 20.3999998,12.7500002",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6809998,23.8731001 L17.4793999,18.9040002 C16.9197599,18.3443602 16.1039299,18.1257402 15.3394399,18.3305902 C14.5749499,18.5354402 13.9777399,19.1326502 13.7729239,19.8971401 C13.5680569,20.6616301 13.7866429,21.4774601 14.3462999,22.0371001 L20.3540998,28.8150001 L20.3540998,33.065 C20.3540998,35.0727 23.2219998,38.2415 23.2219998,38.2415",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3336998,29.2876001 C19.9518798,31.5188501 18.0176199,33.15 15.7538999,33.15 L4.64609996,33.15 C2.08013698,33.15 0,31.0698801 0,28.5039001 L0,4.64440027 C0,3.41234228 0.489548996,2.23075729 1.36091799,1.3597113 C2.23226998,0.488665307 3.41404197,-0.000450189072 4.64609996,0 L15.2999999,0 C18.1167299,0 20.3999998,2.28335529 20.3999998,5.10000027 L20.3999998,21.2500001",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 25.5000001,
    x2: 10.1999999,
    y2: 25.5000001,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04138294,14.6097832 C7.78800594,15.5918732 8.96732993,16.1472802 10.1999829,16.0973002 C12.1362829,16.0973002 13.7070829,14.9191832 13.7070829,13.4673832 C13.7070829,12.0155832 12.1362829,10.8374832 10.1999829,10.8374832 C8.26368293,10.8374832 6.69458295,9.65938323 6.69458295,8.20588324 C6.69458295,6.75238326 8.26368293,5.57598327 10.1999829,5.57598327 C11.4324489,5.52690427 12.6113819,6.08210726 13.3585829,7.06348325",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1999999,
    y1: 16.0973002,
    x2: 10.1999999,
    y2: 17.8500002,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1999999,
    y1: 3.82500028,
    x2: 10.1999999,
    y2: 5.57600027,
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingBannerIcon);
export default __webpack_public_path__ + "static/media/marketing-banner-icon.abd22d4a.svg";
export { ForwardRef as ReactComponent };